import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import resolvedTraitsReconciliation from '../../assets/resolved_traits_reconciliation.png';
import Column from '../Column';

const StyledResolvedReconciliationView = styled(Column)`
  padding-top: 65px;
  text-align: center;
  font-family: 'Poppins', sans-serif;

  .MainMessage {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .SubText {
    font-size: 14px;
    font-weight: 300;
  }
  .ResolvedImage {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 24px;
  }
`;

export default function ResolvedReconciliationView() {
  const { t } = useTranslation();

  return (
    <StyledResolvedReconciliationView>
      <img className="ResolvedImage" src={resolvedTraitsReconciliation} alt="Traits records are fully resolved" width="168px" />
      <span className="MainMessage">{t('Traits.Resolved Reconciliation.All Set')}</span>
      <span className="SubText">{t('Traits.Resolved Reconciliation.Success Message')}</span>
    </StyledResolvedReconciliationView>
  );
}
